import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, LogOut, UserCog } from "lucide-react";
import { api, apiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
import { btnPrimary, cardCls, inputCls, labelCls } from "./shared";

export default function ProfileTab() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const changePassword = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/admin/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password changed successfully");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  return (
    <div className="mx-auto max-w-xl space-y-6" data-testid="admin-profile-tab">
      <div className={cardCls}>
        <div className="flex items-center gap-3">
          <UserCog className="text-primary" size={20} />
          <p className="font-display text-lg">Admin profile</p>
        </div>
        <div className="mt-4 space-y-2 text-sm font-light">
          <p data-testid="profile-name"><span className="text-muted-foreground">Name:</span> {user?.name || "Anaya Owner"}</p>
          <p data-testid="profile-email"><span className="text-muted-foreground">Email:</span> {user?.email}</p>
          <p><span className="text-muted-foreground">Role:</span> <span className="uppercase text-xs tracking-widest">{user?.role}</span></p>
        </div>
      </div>

      <form onSubmit={changePassword} className={cardCls} data-testid="change-password-form">
        <div className="flex items-center gap-3">
          <KeyRound className="text-primary" size={20} />
          <p className="font-display text-lg">Change password</p>
        </div>
        <div className="mt-4 space-y-4">
          <label className={labelCls}>Current password
            <input data-testid="current-password-input" type="password" required className={inputCls} value={form.current_password}
              onChange={(e) => setForm((f) => ({ ...f, current_password: e.target.value }))} /></label>
          <label className={labelCls}>New password (min 8 characters)
            <input data-testid="new-password-input" type="password" required minLength={8} className={inputCls} value={form.new_password}
              onChange={(e) => setForm((f) => ({ ...f, new_password: e.target.value }))} /></label>
          <label className={labelCls}>Confirm new password
            <input data-testid="confirm-password-input" type="password" required minLength={8} className={inputCls} value={form.confirm}
              onChange={(e) => setForm((f) => ({ ...f, confirm: e.target.value }))} /></label>
        </div>
        <button type="submit" data-testid="change-password-btn" disabled={busy} className={`${btnPrimary} mt-5`}>
          {busy ? "Saving…" : "Change password"}
        </button>
      </form>

      <button data-testid="profile-logout-btn" onClick={async () => { await logout(); navigate("/admin/login"); }}
        className="flex w-full items-center justify-center gap-2 rounded-full border border-destructive/40 px-5 py-3 text-xs tracking-[0.15em] text-destructive uppercase hover:bg-destructive/10">
        <LogOut size={14} /> Secure logout
      </button>
    </div>
  );
}
